import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeSection: null,
  unitState: {},
  itemUnits: {},
  chartConfig: {},
};

const mainActiveSlice = createSlice({
  name: "form state",
  initialState,
  reducers: {
    setActiveSectionState(state, action) {
      state.activeSection = action.payload;
    },
    setUnitState(state, action) {
      state.unitState = action.payload;
    },
    setChartConfig(state, action) {
      state.chartConfig = action.payload;
    },
    setItemUnits(state, action) {
      state.itemUnits = action.payload;
    },
  },
});

export const mainActiveActions = mainActiveSlice.actions;

export default mainActiveSlice.reducer;

// mainActiveActions
